export default __webpack_public_path__ + "static/media/hsc.44837485.png";